import { render, staticRenderFns } from "./GeneralStats.vue?vue&type=template&id=5f698a14&scoped=true&"
import script from "./GeneralStats.vue?vue&type=script&lang=js&"
export * from "./GeneralStats.vue?vue&type=script&lang=js&"
import style0 from "./GeneralStats.vue?vue&type=style&index=0&id=5f698a14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f698a14",
  null
  
)

export default component.exports